import fillCrudMetadataGaps, { PartialCrudMetadata, PartialField } from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import type { Tenant } from '../../types';
const getProxyRateScopeFields = (scopeType: string, groupName: string): Array<PartialField<any, Credential>> => {
  const shouldRender = i => i[`${scopeType}FilterEnabled`];
  return [{
    custom_groupName: groupName,
    label: 'Tipo de Tarifa',
    name: `${scopeType}RateType` as keyof Credential,
    default: null,
    type: 'textarray',
    options: [{
      label: 'Net',
      value: 'NET'
    }, {
      label: 'Comissionada',
      value: 'COMMISSION'
    }],
    custom_withNullSelector: true,
    custom_nullSelectorDeselectValue: [],
    renderForm: i => shouldRender(i) ? true : false
  }, {
    custom_groupName: groupName,
    label: 'Valor mínimo de comissão',
    name: `${scopeType}MinimumCommission` as keyof Credential,
    default: null,
    type: 'float',
    inputType: 'percentage',
    renderForm: i => shouldRender(i) && i[`${scopeType}RateType`] && i[`${scopeType}RateType`].includes('COMMISSION') ? true : false
  }, {
    custom_groupName: groupName,
    name: `${scopeType}PackageAllowed` as keyof Credential,
    label: 'Permitir tarifas pacotes',
    default: null,
    custom_withNullSelector: true,
    custom_nullSelectorDeselectValue: false,
    type: 'boolean',
    renderForm: i => shouldRender(i) ? true : false
  }, {
    custom_groupName: groupName,
    label: 'Tipo de Política de Cancelamento',
    name: `${scopeType}CancelPolicy` as keyof Credential,
    default: null,
    type: 'textarray',
    options: [{
      label: 'Grátis',
      value: 'NORMAL'
    }, {
      label: 'Em penalidade',
      value: 'PENALTY'
    }, {
      label: 'Não reembolsável',
      value: 'NONREFUNDABLE'
    }],
    custom_withNullSelector: true,
    custom_nullSelectorDeselectValue: [],
    renderForm: i => shouldRender(i) ? true : false
  }, {
    custom_groupName: groupName,
    label: 'Remover tarifas sem café',
    name: `${scopeType}RemoveRatePlanWithoutBreakfast` as keyof Credential,
    default: null,
    type: 'boolean',
    custom_withNullSelector: true,
    custom_nullSelectorDeselectValue: false,
    renderForm: i => shouldRender(i) ? true : false
  }];
};
const starOptions = [{
  label: '0 estrelas',
  value: 0
}, {
  label: '1 estrela',
  value: 1
}, {
  label: '2 estrelas',
  value: 2
}, {
  label: '3 estrelas',
  value: 3
}, {
  label: '4 estrelas',
  value: 4
}, {
  label: '5 estrelas',
  value: 5
}];
export const partialMetadata: PartialCrudMetadata = {
  label: 'Regra de resultado',
  labelPlural: 'Regras de resultado',
  name: 'HotelPostSearchRule',
  deletable: false,
  updatable: true,
  insertable: true,
  searchable: true,
  authorization: authorization('clientConsultant', 'admin'),
  custom_withAudit: true,
  custom_blockRecord: true,
  dynamoDB: {
    tableName: 'SpearHotelSearchRule'
  },
  columnNames: ['id', 'description', 'type', 'enabled'],
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    id: true,
    insertable: false,
    updatable: false,
    renderForm: false,
    renderColumn: false
  }, {
    custom_groupName: 'Informações básicas',
    label: 'Descrição',
    name: 'description',
    type: 'text',
    hint: 'Descriação da configuração para uso interno'
  }, {
    name: 'enabled',
    label: 'Ativo',
    default: true,
    required: true,
    type: 'boolean'
  }, {
    custom_groupName: 'Informações básicas',
    label: 'Tipo de regra',
    name: 'type',
    type: 'text',
    default: 'POST',
    updatable: false,
    options: [{
      value: 'PRE',
      label: 'Antes da busca'
    }, {
      value: 'POST',
      label: 'Após a busca'
    }],
    render: false
  }, {
    custom_groupName: "Filtro por tipo de tarifa",
    label: 'Aplicar filtro personalizado para tarifas públicas',
    name: 'publicFilterEnabled',
    default: true,
    custom_withNullSelector: true,
    custom_nullSelectorDeselectValue: false,
    type: 'boolean'
  }, {
    custom_groupName: "Filtro por tipo de tarifa",
    label: 'Aplicar filtro personalizado para tarifas privadas',
    name: 'privateFilterEnabled',
    default: true,
    custom_withNullSelector: true,
    custom_nullSelectorDeselectValue: false,
    type: 'boolean'
  }, ...getProxyRateScopeFields('public', "Filtros de tarifa pública"), ...getProxyRateScopeFields('private', "Filtros de tarifa privada"), {
    custom_groupName: 'Categoria de hotel',
    label: 'Número mínimo de estrelas permitido',
    name: 'minHotelAward',
    inputType: 'select',
    options: starOptions
  }, {
    custom_groupName: 'Categoria de hotel',
    label: 'Número máximo de estrelas permitido',
    name: 'maxHotelAward',
    inputType: 'select',
    options: starOptions
  }, {
    custom_groupName: 'Configuração de exibição do preço',
    name: 'priceDisplayMode',
    label: 'Mostrar Preço total',
    inputType: 'select',
    options: [{
      label: 'Total',
      value: 'TOTAL'
    }, {
      label: 'Por noite',
      value: 'PER_NIGHT'
    }]
  }, {
    custom_groupName: 'Configuração de exibição do tarifário',
    name: 'showRatePlanNameConfig_b2c',
    label: 'Fluxo reserva (B2C)',
    type: 'textarray',
    options: [{
      label: 'Cotação',
      value: 'QUOTATION'
    }, {
      label: 'OTA Builder / Motor Niara',
      value: 'OTA_BUILDER'
    }],
    default: []
  }, {
    custom_groupName: 'Configuração de exibição do tarifário',
    name: 'showRatePlanNameConfig_b2b',
    label: 'Fluxo reserva (B2B)',
    type: 'textarray',
    options: [{
      label: 'Usuário de clientes visualizando o nome do tarifário',
      value: 'CLIENT_USER'
    }],
    default: []
  }, {
    custom_groupName: 'Configuração de exibição do tarifário',
    name: 'showRatePlanNameConfig_tenant',
    label: 'Fluxo reserva (instalação)',
    type: 'textarray',
    options: [{
      label: 'Usuário da instalação visualizando o nome do tarifário',
      value: 'TENANT_USER'
    }],
    default: ['TENANT_USER']
  }, {
    custom_groupName: 'Configuração de exibição da quantidade de quartos disponíveis',
    name: 'showRoomAvailabilityConfig_b2c',
    label: 'Fluxo reserva (B2C)',
    type: 'text',
    required: true,
    options: [{
      label: 'Exibir quartos disponíveis quando for menor ou igual a 5 unidades',
      value: 'LESS_THAN_5'
    }, {
      label: 'Não exibir quantidade de quartos disponíveis',
      value: 'NONE'
    }, {
      label: 'Exibir todo inventário de quartos disponíveis',
      value: 'ALL'
    }],
    default: 'LESS_THAN_5'
  }, {
    custom_groupName: 'Configuração de exibição da quantidade de quartos disponíveis',
    name: 'showRoomAvailabilityConfig_b2b',
    label: 'Fluxo reserva (B2B)',
    type: 'text',
    required: true,
    options: [{
      label: 'Exibir quartos disponíveis quando for menor ou igual a 5 unidades',
      value: 'LESS_THAN_5'
    }, {
      label: 'Não exibir quantidade de quartos disponíveis',
      value: 'NONE'
    }, {
      label: 'Exibir todo inventário de quartos disponíveis',
      value: 'ALL'
    }],
    default: 'LESS_THAN_5'
  }, {
    custom_groupName: 'Configuração de exibição da quantidade de quartos disponíveis',
    name: 'showRoomAvailabilityConfig_tenant',
    label: 'Fluxo reserva (Instalação)',
    type: 'text',
    required: true,
    options: [{
      label: 'Exibir quartos disponíveis quando for menor ou igual a 5 unidades',
      value: 'LESS_THAN_5'
    }, {
      label: 'Não exibir quantidade de quartos disponíveis',
      value: 'NONE'
    }, {
      label: 'Exibir todo inventário de quartos disponíveis',
      value: 'ALL'
    }],
    default: 'ALL'
  }, {
    custom_groupName: 'Configuração de exibição dos resultados da busca',
    name: 'hotelAmountPerPage',
    label: 'Quantidade de hotéis por página',
    type: 'int',
    options: [{
      label: '5',
      value: 5
    }, {
      label: '10',
      value: 10
    }, {
      label: '15',
      value: 15
    }, {
      label: '20',
      value: 20
    }],
    default: 10
  }, {
    name: 'returnOnlyPromoCodeForUnauthenticated',
    default: false,
    required: true,
    type: 'boolean',
    label: 'Fluxo reserva (B2C)',
    custom_groupName: 'Exibição somente de tarifas com o Código Promocional'
  }, {
    name: 'returnOnlyPromoCodeForClient',
    default: false,
    required: true,
    type: 'boolean',
    label: 'Fluxo reserva (B2B)',
    custom_groupName: 'Exibição somente de tarifas com o Código Promocional'
  }, {
    name: 'returnOnlyPromoCodeForInstallation',
    default: false,
    required: true,
    type: 'boolean',
    label: 'Fluxo reserva (instalação)',
    custom_groupName: 'Exibição somente de tarifas com o Código Promocional'
  }, {
    name: 'expandTermsAndPolicies',
    default: false,
    type: 'boolean',
    label: 'Trazer expandido o textos das políticas de hotel (Leia mais) da tela de checkout',
    custom_groupName: 'Configuração para expandir políticas na tela de checkout'
  }, {
    name: 'bestPriceEnabled',
    default: false,
    type: 'boolean',
    label: 'Retorna somente tarifas Best Price',
    hint: 'Aplicável apenas ao conteúdo Omnibees',
    custom_checkTenant: (t: Tenant) => t && t.modules_bestPrice,
    custom_groupName: 'Best Price'
  }, {
    name: 'bestPriceCheckPaymentTypes',
    default: false,
    type: 'boolean',
    label: 'Verificar formas de pagamento',
    hint: 'Considerar as formas de pagamento ao comparar tarifas semelhantes',
    renderForm: i => i.bestPriceEnabled,
    custom_checkTenant: (t: Tenant) => t && t.modules_bestPrice,
    custom_groupName: 'Best Price'
  }],
  filter: [{
    name: 'type_eq',
    field: 'type',
    op: 'eq'
  }]
};
export default fillCrudMetadataGaps({
  ...partialMetadata
});